module.exports = __webpack_public_path__ + "static/media/promo_help_pic_agency@2x.746a490f652d245141a174668109cc4b.png";